import { SVGVehicleModel } from "./../../vehicle/models/vehicle.model";
import { AuthService } from "./../../shared/models/auth.service";
import { Injectable, Inject } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { SharedVehicleGroupModel } from "./sharedvehiclegroup.model";
import { Observable } from "rxjs/Observable";
import { WeGoConfig, IAPIResponse, DataListModel } from "../../shared/config";

@Injectable()
export class SharedVehicleGroupService {
  constructor(private authService: AuthService, private http: Http) { }

  public GetSharedVehicleGroupList(
    input?: DataListModel,
    companyHashIdList?: string,
    companyHashId?: string,
    vehicleHashId?: string,
    permissionName?: string
  ): Observable<IAPIResponse> {
    let getSVGUrl = WeGoConfig.API_GET_SHAREDVEHICLEGROUP_DETAIL;
    let queryString = this.authService.HandleAPIListInput(input);

    if (queryString) {
      getSVGUrl = getSVGUrl + "?" + queryString;
      if (companyHashIdList) {
        getSVGUrl = getSVGUrl + "&companyHashIdList=" + companyHashIdList;
      }
      if (companyHashId) {
        getSVGUrl = getSVGUrl + "&companyHashId=" + companyHashId;
      }
      if (vehicleHashId) {
        getSVGUrl = getSVGUrl + "&vehicleHashId=" + vehicleHashId;
      }
      if (permissionName) {
        getSVGUrl = getSVGUrl + "&permissionName=" + permissionName;
      }
    } else {
      if (companyHashIdList) {
        getSVGUrl = getSVGUrl + "&companyHashIdList=" + companyHashIdList;
      }
      if (companyHashId) {
        getSVGUrl = getSVGUrl + "?companyHashId=" + companyHashId;
        if (vehicleHashId) {
          getSVGUrl = getSVGUrl + "&vehicleHashId=" + vehicleHashId;
        }
      } else {
        if (vehicleHashId) {
          getSVGUrl = getSVGUrl + "?vehicleHashId=" + vehicleHashId;
        }
      }
      if (getSVGUrl.indexOf("?")) {
        if (permissionName) {
          getSVGUrl = getSVGUrl + "&permissionName=" + permissionName;
        }
      } else {
        if (permissionName) {
          getSVGUrl = getSVGUrl + "?permissionName=" + permissionName;
        }
      }
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getSVGUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportSharedVehicleGroupList(
    companyHashID?: string,
    vehicleHashId?: string,
    input?: DataListModel
  ): any {
    let getSVGUrl = WeGoConfig.API_EXPORT_SHAREDVEHICLEGROUP_LIST;
    input.currentPage = 0;
    let queryString = this.authService.HandleAPIListInput(input);
    if (companyHashID) {
      getSVGUrl =
        getSVGUrl + "?" + queryString + "&companyHashID=" + companyHashID;
    } else {
      getSVGUrl = getSVGUrl + "?" + queryString;
    }
    if (vehicleHashId) {
      getSVGUrl = getSVGUrl + "&vehicleHashId=" + vehicleHashId;
    }
    let headers = this.authService.GetHeader("text/csv");
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getSVGUrl, options);
  }

  public AddSharedVehicleGroupModel(
    sharedVehicleGroupModel: SharedVehicleGroupModel
  ): Observable<IAPIResponse> {
    let body = sharedVehicleGroupModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_POST_SHAREDVEHICLEGROUP_DETAIL, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
  public GetSharedVehicleGroupHashId(
    sharedvehiclegroupHashId: string
  ): Observable<IAPIResponse> {
    let getSharedVehicleGroupUrl =
      WeGoConfig.API_GET_SHAREDVEHICLEGROUP_BY_HASH +
      "?sharedVehicleGroupHashId=" +
      sharedvehiclegroupHashId;

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getSharedVehicleGroupUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetSharedVehicleGroupBasicDetail(
    sharedvehiclegroupHashId: string
  ): Observable<IAPIResponse> {
    let getSharedVehicleGroupUrl =
      WeGoConfig.API_GET_SHAREDVEHICLEGROUP_BASIC_DETAIL +
      "?sharedVehicleGroupHashId=" +
      sharedvehiclegroupHashId;

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getSharedVehicleGroupUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetSVGListForDrivers(
    driverMasterHashId: string,
    input?: DataListModel
  ): Observable<IAPIResponse> {
    let getSharedVehicleGroup = WeGoConfig.API_GET_SVG_LIST_FOR_DRIVERS;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getSharedVehicleGroup =
        getSharedVehicleGroup +
        "?" +
        queryString +
        "&driverMasterHashId=" +
        driverMasterHashId;
    } else {
      getSharedVehicleGroup =
        getSharedVehicleGroup + "?driverMasterHashId=" + driverMasterHashId;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getSharedVehicleGroup, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetSVGListForBatchUpload(
    instanceHashId: string,
    organizationMasterHashId: string,
    input?: DataListModel
  ): Observable<IAPIResponse> {
    let getSVGForBatchUploadDetail =
      WeGoConfig.API_POST_SVG_DETAIL_FOR_BATCHUPLOAD;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getSVGForBatchUploadDetail =
        getSVGForBatchUploadDetail +
        "?" +
        queryString +
        "&instanceId=" +
        instanceHashId;
    } else {
      getSVGForBatchUploadDetail =
        getSVGForBatchUploadDetail + "?instanceId=" + instanceHashId;
    }

    if (organizationMasterHashId != "") {
      getSVGForBatchUploadDetail =
        getSVGForBatchUploadDetail +
        "&organizationMasterId=" +
        organizationMasterHashId;
    }

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getSVGForBatchUploadDetail, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetSVGListForVehicle(
    vehicleMasterHashId: string,
    input?: DataListModel
  ): Observable<IAPIResponse> {
    let getSharedVehicleGroup = WeGoConfig.API_GET_SVG_LIST_FOR_VEHICLE;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getSharedVehicleGroup =
        getSharedVehicleGroup +
        "?" +
        queryString +
        "&vehicleMasterHashId=" +
        vehicleMasterHashId;
    } else {
      getSharedVehicleGroup =
        getSharedVehicleGroup + "?vehicleMasterHashId=" + vehicleMasterHashId;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getSharedVehicleGroup, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
  public DeleteSharedVehicleGroup(
    selectedsharedVehicelGroupHashId: string[]
  ): Observable<IAPIResponse> {
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .post(
        WeGoConfig.API_POST_DELETE_SVG_VEHICLE_DETAIL,
        selectedsharedVehicelGroupHashId,
        options
      )
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
  public GetSVGVehicleList(
    sharedvehiclegroupHashId: string,
    input?: DataListModel
  ): Observable<IAPIResponse> {
    let getSVGVehicleList = WeGoConfig.API_GET_SVGVEHICLEGLIST;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getSVGVehicleList =
        getSVGVehicleList +
        "?" +
        queryString +
        "&sharedVehicleGroupHashId=" +
        sharedvehiclegroupHashId;
    } else {
      getSVGVehicleList =
        getSVGVehicleList +
        "?sharedVehicleGroupHashId=" +
        sharedvehiclegroupHashId;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getSVGVehicleList, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
  public AssignGroupVehicle(
    SVGvehicleModel: SVGVehicleModel
  ): Observable<IAPIResponse> {
    let body = SVGvehicleModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_POST_SVG_VEHICLE_DETAIL, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
  public GetVehicleListForGroup(
    sharedvehiclegroupHashId: string,
    input?: DataListModel
  ): Observable<IAPIResponse> {
    let getSVGVehicleList = WeGoConfig.API_GET_VEHICLEGROUP_LIST;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getSVGVehicleList =
        getSVGVehicleList +
        "?" +
        queryString +
        "&sharedVehicleGroupHashId=" +
        sharedvehiclegroupHashId;
    } else {
      getSVGVehicleList =
        getSVGVehicleList +
        "?sharedVehicleGroupHashId=" +
        sharedvehiclegroupHashId;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getSVGVehicleList, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public DeleteVehicleSVG(
    selectedVehicleSVGList: string[]
  ): Observable<IAPIResponse> {
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(
        WeGoConfig.API_POST_DELETE_VEHICLE_SVG,
        selectedVehicleSVGList,
        options
      )
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public InActiveSharedVehicleGroup(svgHashId: string) {
    let getInactiveSVGUrl =
      WeGoConfig.API_GET_INACTIVE_SHAREDVEHICLEGROUP +
      "?sharedVehicleGroupHashId=" +
      svgHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getInactiveSVGUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetSVGDriverList(
    sharedvehiclegroupHashId: string,
    instanceHashId: string,
    companyHashId: string,
    input?: DataListModel
  ): Observable<IAPIResponse> {
    let getSVGDriverList = WeGoConfig.API_GET_SVGDRIVERGLIST;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getSVGDriverList =
        getSVGDriverList +
        "?" +
        queryString +
        "&sharedVehicleGroupHashId=" +
        sharedvehiclegroupHashId +
        "&instanceHashId=" +
        instanceHashId +
        "&companyHashId=" +
        companyHashId;
    } else {
      getSVGDriverList =
        getSVGDriverList +
        "?sharedVehicleGroupHashId=" +
        sharedvehiclegroupHashId +
        "&instanceHashId=" +
        instanceHashId +
        "&companyHashId=" +
        companyHashId;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getSVGDriverList, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetDropdownSVGList(
    reportName: string,
    companyHashId: string,
    instanceHashId?: string
  ): Observable<IAPIResponse> {
    let getSVGUrl: string;

    switch (reportName) {
      case "Vehicle_Occupancy_Report":
        getSVGUrl = WeGoConfig.API_GET_DROPDOWN_SVG_LIST_VEHICLEOCCUPANCYREPORT;
        break;
      case "Revenue_Per_Vehicle_Report":
        getSVGUrl = WeGoConfig.API_GET_DROPDOWN_SVG_LIST_REVENUEVEHICLEREPORT;
        break;
      case "Maintenance_Planning_Report":
        getSVGUrl =
          WeGoConfig.API_GET_DROPDOWN_SVG_LIST_MAINTENCEPLANNINGREPORT;
        break;
      case "TripData_Report":
        getSVGUrl = WeGoConfig.API_GET_DROPDOWN_SVG_LIST_TRIPDATAREPORT;
        break;
      case "Admin_Dashboard":
        getSVGUrl = WeGoConfig.API_GET_DROPDOWN_SVG_LIST_DASHBOARD;
        break;
      case "Kick_Back_Report":
        getSVGUrl = WeGoConfig.API_GET_DROPDOWN_SVG_LIST_KICK_BACK_REPORT;
        break;
      case "Pre Post Trip Question":
        getSVGUrl = WeGoConfig.API_GET_DROPDOWN_SVG_LIST_PRE_POST_TRIP_QUESTION;
        break;
      default:
        getSVGUrl = WeGoConfig.API_GET_DROPDOWN_SVG_LIST_VEHICLEOCCUPANCYREPORT;
        break;
    }

    getSVGUrl = getSVGUrl + "?companyHashId=" + companyHashId;

    if (instanceHashId) {
      getSVGUrl = getSVGUrl + "&instanceHashId=" + instanceHashId;
    }

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getSVGUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetDropdownDriverList(
    sharedvehiclegroupHashId: string,
    organizationHashId: string,
    instanceHashId: string,
    companyHashId: string,
    input?: DataListModel
  ): Observable<IAPIResponse> {
    let getSVGDriverList = WeGoConfig.API_GET_DROPDOWN_DRIVER_LIST;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getSVGDriverList =
        getSVGDriverList +
        "?" +
        queryString +
        "&sharedVehicleGroupHashId=" +
        sharedvehiclegroupHashId +
        "&organizationHashId=" + organizationHashId +
        "&instanceHashId=" +
        instanceHashId +
        "&companyHashId=" +
        companyHashId;
    } else {
      getSVGDriverList =
        getSVGDriverList +
        "?sharedVehicleGroupHashId=" +
        sharedvehiclegroupHashId +
        "&organizationHashId=" + organizationHashId +
        "&instanceHashId=" +
        instanceHashId +
        "&companyHashId=" +
        companyHashId;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getSVGDriverList, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetSharedVehicleDropdownList(): Observable<IAPIResponse> {
    let getSVGListUrl = WeGoConfig.API_GET_DROPDOWN_SVG_LIST_BOOKING_AGENDA;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getSVGListUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetSharedVehicleDropdownListByOrganization(
    reportName: string,
    permissionType: string,
    organizationHashId: string
  ): Observable<IAPIResponse> {
    let getSVGListUrl = WeGoConfig.API_GET_DROPDOWN_SVG_LIST_TEMPLATE;

    switch (reportName) {
      case "Template":
        getSVGListUrl = WeGoConfig.API_GET_DROPDOWN_SVG_LIST_TEMPLATE;
        break;
      case "Terms_And_Condition":
        getSVGListUrl = WeGoConfig.API_GET_DROPDOWN_SVG_LIST_TERMS_AND_CONDITION;
        break;
    }

    if (permissionType) {
      getSVGListUrl = getSVGListUrl + "?permissionType=" + permissionType;
    }

    if (organizationHashId) {
      getSVGListUrl =
        getSVGListUrl + "&organizationHashId=" + organizationHashId;
    }

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getSVGListUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ResetTwoFaCookies(SharedVehicleGroupHashId: string): Observable<IAPIResponse> {
    let getInstanceUrl =
      WeGoConfig.API_RESET_TWOFA_COOKIES_SVG + "?SharedVehicleGroupHashId=" + SharedVehicleGroupHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getInstanceUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ResetTwoFaKeys(SharedVehicleGroupHashId: string): Observable<IAPIResponse> {
    let getInstanceUrl =
      WeGoConfig.API_RESET_TWOFA_KEYS_SVG + "?SharedVehicleGroupHashId=" + SharedVehicleGroupHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getInstanceUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetDropdownSharedVehicleGroupListByCompanyIdList(reportName: string, permissionType: string, organizationHashIds: string[]): Observable<IAPIResponse> {
    let getOrganizationUrl: string;

    switch (reportName) {
      case "Terms_And_Condition":
        getOrganizationUrl = WeGoConfig.API_GET_DROPDOWN_SVG_LIST_BY_ORG_LIST_TERMS_AND_CONDITION;
        break;
    }

    if (permissionType) {
      getOrganizationUrl = getOrganizationUrl + '?permissionType=' + permissionType;
    }

    let queryString = '';
    organizationHashIds.forEach(element => {
      queryString += "&organizationHashIdList=" + element;
    })

    getOrganizationUrl = getOrganizationUrl + queryString;

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getOrganizationUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/sharedvehiclegroup/models/sharedvehiclegroup.service.ts